import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["title", "aria-label"]
const _hoisted_2 = {
  key: 1,
  class: "time-line"
}
const _hoisted_3 = ["title", "aria-label"]

import { computed } from 'vue';
import { useRouter } from 'vue-router';

import { t } from '@services/l10n';
import { isPartiallyInViewport } from '@services/viewport';
import { useRouteIs } from '@services/route-is';
import { fragment } from '@services/route-fragment';
import * as utils from '@services/utils/common';
import * as nativex from '@native';

import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue';

import type { IPhoto } from '@typings';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ViewerDateAddress',
},
  __name: 'ViewerDateAddress',
  props: {
    photo: { default: null },
    twoLines: { type: Boolean, default: false }
  },
  setup(__props: any) {



const props = __props;

const router = useRouter();
const routeIs = useRouteIs();
const dateStr = computed((): string | null => {
  const date = props.photo?.imageInfo?.datetaken;
  if (!date) return null;
  return utils.getDateStr(new Date(date * 1000));
});

const timeStr = computed((): string | null => {
  const date = props.photo?.imageInfo?.datetaken;
  if (!date) return null;
  return utils.getTimeStr(new Date(date * 1000));
});

const dateTaken = computed((): string | null => {
  const date = props.photo?.imageInfo?.datetaken;
  if (!date) return null;
  return utils.getLongDateStr(new Date(date * 1000), false, true);
});

const addressShort = computed((): string | null => {
  return props.photo?.imageInfo?.address_short ?? null;
});

const dayTo = computed(() => {
  if (!props.photo?.imageInfo?.intimeline) return undefined;

  // We need the real dayid to jump to anywhere in the timeline,
  // even if the current view is a month view. Note that this means
  // the target view cannot be a month view :/
  const dayid = props.photo.dayid_real ?? props.photo.dayid;

  // We use the fileid, not the key. The key may not be the same as the
  // timeline's fileid, for example on faces where the key is the faceid.
  const fileid = props.photo.fileid;

  // Both parameters are required for jumping.
  if (!dayid || !fileid) return undefined;

  return {
    name: 'timeline',
    hash: `#${fragment.types.day}/${dayid}/${fileid}`,
  };
});

async function jumpToTimeline() {
  if (!dayTo.value) return;
  beep();

  // If we are already on the timeline, just close the viewer.
  // This way we don't unnecessarily accumulate history entries.
  if (routeIs.Base) {
    await fragment.pop(fragment.types.viewer);

    // Check if the image is alraedy in the viewport, and scroll only if not.
    // This is to avoid the annoying "jump" when closing the viewer.
    const photoEl = document.querySelector<HTMLDivElement>(`.p-outer--${props.photo?.key}`);
    if (!photoEl || !isPartiallyInViewport(photoEl)) {
      await router.replace(dayTo.value);
    }
    return;
  }

  // On another route - push an entry in navigation so that pressing
  // back will bring us back to an open viewer at the same spot.
  try {
    await router.push(dayTo.value);
  } catch {
    // e.g. duplicated navigation; nothing to do
  }
}

function beep() {
  nativex.playTouchSound();
}

return (_ctx: any,_cache: any) => {
  return (__props.twoLines)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (dateStr.value && !_unref(routeIs).Public)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["date-line", { 'is-link': dayTo.value }]),
              title: _unref(t)('memories', 'Show in timeline'),
              "aria-label": _unref(t)('memories', 'Show in timeline'),
              onClick: _withModifiers(jumpToTimeline, ["stop"])
            }, [
              _createTextVNode(_toDisplayString(dateStr.value) + " ", 1),
              (dayTo.value)
                ? (_openBlock(), _createBlock(ChevronRightIcon, {
                    key: 0,
                    class: "chev",
                    size: 20
                  }))
                : _createCommentVNode("", true)
            ], 10, _hoisted_1))
          : _createCommentVNode("", true),
        (timeStr.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(timeStr.value), 1),
              (addressShort.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" • " + _toDisplayString(addressShort.value), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (dateTaken.value && !_unref(routeIs).Public)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["exif date", { 'is-link': dayTo.value }]),
              title: _unref(t)('memories', 'Show in timeline'),
              "aria-label": _unref(t)('memories', 'Show in timeline'),
              onClick: _withModifiers(jumpToTimeline, ["stop"])
            }, [
              _createTextVNode(_toDisplayString(dateTaken.value), 1),
              (addressShort.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" • " + _toDisplayString(addressShort.value), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (dayTo.value)
                ? (_openBlock(), _createBlock(ChevronRightIcon, {
                    key: 1,
                    class: "chev",
                    size: 18
                  }))
                : _createCommentVNode("", true)
            ], 10, _hoisted_3))
          : _createCommentVNode("", true)
      ], 64))
}
}

})